module.exports = __webpack_public_path__ + "static/media/18.1e7ffce3.svg";